import { motion, useInView } from 'framer-motion'
import { useRef } from 'react'
import type { TypeCount } from '@/types/statistics'

const BAR_COLORS = [
  'bg-blue-500', 'bg-indigo-500', 'bg-purple-500', 'bg-amber-500',
  'bg-green-500', 'bg-cyan-500', 'bg-rose-500', 'bg-orange-500',
  'bg-teal-500', 'bg-pink-500', 'bg-gray-500',
]

interface Props {
  data: TypeCount[]
}

export default function FacilityTypeChart({ data }: Props) {
  const ref = useRef<HTMLDivElement>(null)
  const isInView = useInView(ref, { once: true, margin: '-50px' })

  const maxCount = Math.max(...data.map((d) => d.count), 1)
  // 상위 8개만 표시
  const top = data.slice(0, 8)

  return (
    <div ref={ref} className="flex flex-col gap-3">
      {top.map((item, i) => {
        const pct = (item.count / maxCount) * 100
        const barColor = BAR_COLORS[i % BAR_COLORS.length]

        return (
          <div key={item.facilityType}>
            <div className="flex items-center justify-between mb-1">
              <span className="text-xs font-medium text-cb-gray-700 truncate">{item.facilityTypeName}</span>
              <span className="text-xs font-bold text-cb-gray-900 ml-2 flex-shrink-0">
                {item.count.toLocaleString()}
              </span>
            </div>
            <div className="h-3 rounded-full bg-cb-gray-100 overflow-hidden">
              <motion.div
                className={`h-full rounded-full ${barColor}`}
                initial={{ width: 0 }}
                animate={isInView ? { width: `${pct}%` } : { width: 0 }}
                transition={{ duration: 0.6, delay: i * 0.06, ease: [0.25, 0.1, 0.25, 1] }}
              />
            </div>
          </div>
        )
      })}
    </div>
  )
}
